import { useEffect, useRef, useState } from 'react';

interface CourseCardProps {
  course: {
    id: number;
    sno: number;
    instructor: string;
    title: string;
    date: string;
    session: string;
    capacity: number;
    isPending?: boolean;
  };
  index: number;
}

const CourseCard = ({ course, index }: CourseCardProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className="group bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 hover:border-[#C9A84C]/30"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: `all 0.6s ease-out ${index * 80}ms`,
      }}
    >
      <div className="flex items-stretch">
        {/* Sol numara şeridi */}
        <div className="w-16 flex-shrink-0 bg-[#0D1B3E] flex flex-col items-center justify-center py-6 relative overflow-hidden group-hover:bg-[#C9A84C] transition-colors duration-500">
          <span className="text-[#C9A84C] group-hover:text-[#0D1B3E] text-xs font-semibold uppercase tracking-widest transition-colors duration-500" style={{writingMode: 'vertical-rl', transform: 'rotate(180deg)'}}>Kurs</span>
          <span className="text-white group-hover:text-[#0D1B3E] text-2xl font-bold mt-2 transition-colors duration-500">{course.sno}</span>
        </div>

        {/* İçerik */}
        <div className="flex-1 p-6">
          {course.isPending ? (
            <div className="flex items-center gap-2 mb-3">
              <span className="px-3 py-1 bg-amber-50 text-amber-600 text-xs font-semibold rounded-full border border-amber-200">
                Hoca İsmi Açıklanacak
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-user-star-line text-[#C9A84C] text-sm"></i>
              </div>
              <span className="text-[#C9A84C] text-sm font-semibold">{course.instructor}</span>
            </div>
          )}

          <h3 className={`text-base font-bold leading-snug mb-4 ${course.isPending ? 'text-gray-400 italic' : 'text-[#0D1B3E]'}`}>
            {course.title}
          </h3>

          <div className="flex flex-wrap gap-3">
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <div className="w-7 h-7 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-100">
                <i className="ri-calendar-event-line text-xs text-[#0D1B3E]"></i>
              </div>
              <span>{course.date}</span>
            </div>

            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <div className="w-7 h-7 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-100">
                <i className="ri-time-line text-xs text-[#0D1B3E]"></i>
              </div>
              <span>{course.session}</span>
            </div>

            <div className="flex items-center gap-2 text-sm">
              <div className="w-7 h-7 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-100">
                <i className="ri-group-line text-xs text-[#0D1B3E]"></i>
              </div>
              <span className="text-gray-500">Kontenjan:</span>
              <span className="font-bold text-[#0D1B3E]">{course.capacity} Kişi</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;